import { COLOR_MODES, type ColorMode } from '_styles/material-ui/create-app-theme'
import { COLOR_SCHEME_PREFERENCES, type ColorSchemePreference } from '_stores/color-scheme.store'

export const PREFERS_DARK_QUERY = '(prefers-color-scheme: dark)'

export const resolveColorMode = ({
  isDarkModeEnabled,
  isLightForced = false,
  preference,
  prefersDark,
}: {
  isDarkModeEnabled: boolean
  isLightForced?: boolean
  preference: ColorSchemePreference
  prefersDark: boolean
}): ColorMode => {
  if (!isDarkModeEnabled || isLightForced) {
    return COLOR_MODES.light
  }
  if (preference === COLOR_SCHEME_PREFERENCES.dark) {
    return COLOR_MODES.dark
  }
  if (preference === COLOR_SCHEME_PREFERENCES.system && prefersDark) {
    return COLOR_MODES.dark
  }
  return COLOR_MODES.light
}
